import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useDebounce, useDraggable } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { useTimeoutThrottle } from "@/composables/throttle";
import { determineWidth } from "./utilities";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FlexPanel',
    props: {
        collapsible: {
            type: Boolean,
            default: true,
        },
        side: {
            type: String,
            default: "right",
        },
    },
    setup(__props) {
        const props = __props;
        const { throttle } = useTimeoutThrottle(10);
        library.add(faChevronLeft, faChevronRight);
        const minWidth = 200;
        const maxWidth = 800;
        const defaultWidth = 300;
        const draggable = ref(null);
        const root = ref(null);
        const panelWidth = ref(defaultWidth);
        const show = ref(true);
        const { position, isDragging } = useDraggable(draggable, {
            preventDefault: true,
            exact: true,
        });
        const hoverDraggable = ref(false);
        const hoverDraggableDebounced = useDebounce(hoverDraggable, 100);
        const showHover = computed(() => (hoverDraggable.value && hoverDraggableDebounced.value) || isDragging.value);
        const showToggle = ref(false);
        const hoverToggle = ref(false);
        const hoverDraggableOrToggle = computed(() => (hoverDraggableDebounced.value || hoverToggle.value) && !isDragging.value);
        const toggleLinger = 500;
        const toggleShowDelay = 600;
        let showToggleTimeout;
        watch(() => hoverDraggableOrToggle.value, (hover) => {
            clearTimeout(showToggleTimeout);
            if (hover) {
                showToggleTimeout = setTimeout(() => {
                    showToggle.value = true;
                }, toggleShowDelay);
            }
            else {
                showToggleTimeout = setTimeout(() => {
                    showToggle.value = false;
                }, toggleLinger);
            }
        });
        /** Watch position changes and adjust width accordingly */
        watch(position, () => {
            throttle(() => {
                if (!root.value || !draggable.value) {
                    return;
                }
                const rectRoot = root.value.getBoundingClientRect();
                const rectDraggable = draggable.value.getBoundingClientRect();
                panelWidth.value = determineWidth(rectRoot, rectDraggable, minWidth, maxWidth, props.side, position.value.x);
            });
        });
        function onKeyLeft() {
            if (props.side === "left") {
                decreaseWidth();
            }
            else {
                increaseWidth();
            }
        }
        function onKeyRight() {
            if (props.side === "left") {
                increaseWidth();
            }
            else {
                decreaseWidth();
            }
        }
        function increaseWidth(by = 50) {
            panelWidth.value = Math.min(panelWidth.value + by, maxWidth);
        }
        function decreaseWidth(by = 50) {
            panelWidth.value = Math.max(panelWidth.value - by, minWidth);
        }
        const sideClasses = computed(() => ({
            left: props.side === "left",
            right: props.side === "right",
        }));
        return { __sfc: true, throttle, props, minWidth, maxWidth, defaultWidth, draggable, root, panelWidth, show, position, isDragging, hoverDraggable, hoverDraggableDebounced, showHover, showToggle, hoverToggle, hoverDraggableOrToggle, toggleLinger, toggleShowDelay, showToggleTimeout, onKeyLeft, onKeyRight, increaseWidth, decreaseWidth, sideClasses, FontAwesomeIcon };
    }
});
